{
  "_meta": {
    "_comment": "Phase 14.1 Wave 9 Task 46 — merchant pricing namespace (LiveCostCalculator breakdown, rush toggle, service picker, packing-group summary, price error copy). Money rendered via Money/formatUsd, values from API. vg-binding: P14.1.D-04 / P14.1.D-19 / INTERFACE-STANDARDS:error-shape",
    "locale": "fr"
  },
  "breakdown": {
    "title": "Détail des coûts",
    "subtotal": "Sous-total",
    "productTotal": "Produits",
    "embroideryFee": "Frais de broderie",
    "rushFee": "Frais express",
    "shippingFee": "Livraison",
    "tax": "Taxe",
    "tariff": "Droits de douane",
    "discount": "Remise",
    "total": "Total",
    "estimatedTotal": "Total estimé",
    "perItem": "Par article",
    "empty": "Ajoutez des articles pour voir le détail des coûts."
  },
  "rush": {
    "toggleLabel": "Production express",
    "toggleHint": "Prioriser cette commande pour une production plus rapide. Des frais express s'appliquent par article.",
    "badge": "Express",
    "unavailable": "La production express n'est pas disponible pour cette destination."
  },
  "service": {
    "pickerLabel": "Mode de livraison",
    "pickerPlaceholder": "Choisir un mode de livraison",
    "estimatedDelivery": "Livraison estimée {{window}}"
  },
  "packingGroups": {
    "title": "Groupes d'expédition",
    "groupLabel": "Groupe {{index}}",
    "itemsCount": "{{count}} article(s)",
    "shippingPerGroup": "Livraison pour ce groupe",
    "consolidatedHint": "Les articles expédiés ensemble sont facturés une seule livraison par groupe."
  },
  "errors": {
    "productPriceMissing": "Le tarif d'un ou plusieurs articles n'est pas encore disponible.",
    "shippingFeeMissing": "La livraison n'est pas configurée pour le service et la destination sélectionnés.",
    "priceDrift": "Le prix a changé depuis votre devis. Vérifiez le nouveau total avant de confirmer.",
    "embPaymentNotPending": "Ces frais de broderie ne sont plus en attente de paiement. Actualisez et réessayez.",
    "embFeeQuoteMismatch": "Les frais de broderie ont changé. Vérifiez le nouveau montant avant d'accepter.",
    "walletInsufficient": "Le solde de votre portefeuille est insuffisant. Rechargez et réessayez.",
    "rushFeeZoneMissing": "La production express n'est pas disponible pour un ou plusieurs articles vers cette destination.",
    "generic": "Nous n'avons pas pu calculer le prix. Veuillez réessayer ou contacter le support."
  },
  "status": {
    "calculating": "Calcul en cours…",
    "recalculated": "Prix mis à jour"
  }
}
